import React from 'react';
import PropTypes from 'prop-types';

import SuggestContactButton from '../SuggestContactButton';

export default function AddContactComponent(props) {
  const {
    branchId,
    isSubmitting,
    message,
    onChange,
    onSubmit,
    onSuggestComplete,
    value,
  } = props;

  return (
    <form
      className="act__contact-choice-method"
      method="post"
      onSubmit={onSubmit}
    >
      <label
        className="act__contact-choice-label"
        htmlFor="js-add-a-contact"
        style={{ width: '100% ' }}
      >
        Add a contact
        <input
          id="js-add-a-contact"
          type="text"
          className="form__control form__control--no-border act__form-input"
          onChange={onChange}
          value={value}
        />
      </label>
      <p className="act__add-contact-message" dangerouslySetInnerHTML={{ __html: message }} />
      <p className="buttons act__add-and-suggest-buttons">
        <button
          className="button button--primary"
          disabled={value === '' || isSubmitting}
          type="submit"
        >
          {isSubmitting ? 'Adding...' : 'Add'}
        </button>
        <SuggestContactButton
          branchId={branchId}
          onSuggestComplete={onSuggestComplete}
        />
      </p>
    </form>
  );
}

AddContactComponent.propTypes = {
  branchId: PropTypes.number.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  message: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSuggestComplete: PropTypes.func.isRequired,
  value: PropTypes.string,
};

AddContactComponent.defaultProps = {
  message: '',
  value: '',
};